import { useReducer } from 'react';
import { SkinFoldData } from './types';

// Função reducer para atualizar o estado SkinFoldData
const skinFoldReducer = (state: SkinFoldData, action: SkinFoldAction) => {
  switch (action.type) {
    case 'UPDATE_ALL':
      return { ...(action.payload as SkinFoldData) }; // Atualiza o objeto inteiro
    case 'UPDATE_FIELD':
      return {
        ...state,
        [action.field as unknown as string]: action.payload, // Atualiza campo específico
      };
    default:
      return state;
  }
};

// Interface para ações do reducer
interface SkinFoldAction {
  type: 'UPDATE_ALL' | 'UPDATE_FIELD';
  payload: SkinFoldData | string | number; // Payload depende do tipo de ação
  field?: string; // Campo específico (opcional)
}

// Função customizada para criar o estado inicial e o dispatch
export function useSkinFoldState(initialState: SkinFoldData) {
  const [skinFoldData, dispatch] = useReducer(skinFoldReducer, initialState);

  // Função para atualizar o objeto inteiro
  const updateAll = (data: SkinFoldData) => {
    dispatch({ type: 'UPDATE_ALL', payload: data });
  };

  // Função para atualizar um campo específico
  const updateField = (field: keyof SkinFoldData, value: any) => {
    dispatch({ type: 'UPDATE_FIELD', field, payload: value });
  };

  return { skinFoldData, updateAll, updateField };
}
